import '../INVC/INVC.scss';
import '../../helpers/print.scss';
import './ORDS.scss';
import EmailInvoice from '../../extensions/checkout/EmailInvoice';
import {PageManager} from 'genesis-packages/core';
import 'extensions/ui-components/g-modal';
import 'extensions/invoice-lookup';

export default class ORDS extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		new EmailInvoice();

		/**
		 *  Launch Printer Dialog
		 */
		const printTriggers = document.getElementsByClassName('js-print-invoice');

		if (printTriggers.length) {
			for (let element of printTriggers) {
				element.addEventListener('click', function (e) {
					e.preventDefault();
					window.print();
				}, false);
			}
		}

	}

};
